import { ApplicationProperties, DragObject } from "../../models/Types";
import { Application, Graphics, FederatedPointerEvent, Point } from "pixi.js";
import { Sprite, Texture } from "pixi.js-legacy";

export default class ChallengeUtils {
  public static snap(obj: DragObject) {
    obj.dragging = 0;
  }

  public static drawArc(
    target: any,
    x: any,
    y: any,
    radius: number,
    stroke: number,
    color: number,
    startAngle: number = 0,
    endAngle: number = 0,
  ) {
    target.lineStyle(stroke, color, 1);
    target.arc(x, y, radius, startAngle, endAngle);
  }

  public static drawPolygon(
    target: Graphics,
    x: number,
    y: number,
    sides: number,
    radius: number,
    angle = 0,
  ) {
    const step = (Math.PI * 2) / sides;
    const start = (angle / 180) * Math.PI;
    let n, dx, dy;
    target.moveTo(x + Math.cos(start) * radius, y - Math.sin(start) * radius);
    for (n = 1; n <= sides; ++n) {
      dx = x + Math.cos(start + step * n) * radius;
      dy = y - Math.sin(start + step * n) * radius;
      target.lineTo(dx, dy);
    }
  }

  public static onDragStart(event: FederatedPointerEvent) {
    const obj = event.currentTarget as DragObject;
    obj.dragData = event;

    obj.dragging = 1;
    obj.dragPointerStart = event.data.getLocalPosition(obj.parent);
    obj.dragObjStart = new Point();
    obj.dragObjStart.copyFrom(obj.position);
    obj.dragGlobalStart = new Point();
    obj.dragGlobalStart.copyFrom(event.data.global);
    obj.cursor = "grabbing";

    return true;
  }

  public static onDragEnd(event: FederatedPointerEvent) {
    const obj = event.currentTarget as DragObject;
    if (!obj.dragging) return true;

    ChallengeUtils.snap(obj);

    obj.dragging = 0;
    obj.cursor = "grab";
    return true;
  }

  public static randomNormal(mean: number, stdev: number) {
    // https://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
    const u1 = Math.random();
    const u2 = Math.random();
    if (u1 === 0) {
      return 0;
    }
    const z = Math.sqrt(-2.0 * Math.log(u1)) * Math.cos(2.0 * Math.PI * u2);
    return mean + stdev * z;
  }

  public static clamp(value: number, lo: number, hi: number) {
    return Math.min(Math.max(value, lo), hi);
  }

  public static generateApplication(props: ApplicationProperties) {
    return new Application({
      width: props.width,
      height: props.height,
      backgroundColor:
        props.backgroundColor !== undefined && props.backgroundColor !== null
          ? props.backgroundColor
          : 0xffffff,
      resolution: props.resolution || window.devicePixelRatio || 1,
      antialias: props.antialias || true,
      forceCanvas: props.forceCanvas || true,
      autoDensity: true,
    });
  }

  public static timedCreateSprite(
    url: any,
    onLoadStart?: () => void,
    onLoadEnd?: () => void,
  ): Sprite {
    const sprite = new Sprite(Texture.EMPTY);
    onLoadStart && onLoadStart();
    Texture.fromURL(url).then((texture) => {
      onLoadEnd && onLoadEnd();
      sprite.texture = texture;
    });
    return sprite;
  }
}
